import { Button, Dialog, Flex } from '@servicetitan/anvil2';
import { useDependencies } from '@servicetitan/react-ioc';

import { PhonesActionsCellStore } from '../stores/phones-actions-cell.store';

export const ConfirmDeallocateDialog = () => {
    const [{ hideDialog, handleDeallocate }] = useDependencies(PhonesActionsCellStore);

    return (
        <Dialog open size="large" onClose={hideDialog} onCancel={hideDialog} className="m-t-auto-i">
            <Dialog.Header>Deallocate Phone Number?</Dialog.Header>
            <Dialog.Content>
                By deallocating the phone number will be removed the phones tab.
            </Dialog.Content>
            <Dialog.Footer>
                <Flex justifyContent="flex-end">
                    <Flex gap="3">
                        <Dialog.CancelButton>Cancel</Dialog.CancelButton>
                        <Button appearance="danger" onClick={handleDeallocate}>
                            Deallocate
                        </Button>
                    </Flex>
                </Flex>
            </Dialog.Footer>
        </Dialog>
    );
};
